import { render, staticRenderFns } from "./CollectionSubmit.vue?vue&type=template&id=94a7c58a"
import script from "./CollectionSubmit.vue?vue&type=script&lang=js"
export * from "./CollectionSubmit.vue?vue&type=script&lang=js"
import style0 from "./CollectionSubmit.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports